module.exports = __webpack_public_path__ + "img/fast-underground-belt-structure.31b69934.png";